import { actionTypes } from './constants';
import { get } from 'src/fetch/fetch';
import { QUOTATION_CLASS_LIST_GET, QUOTATION_LIST_GET } from 'src/fetch/url';

export function initQuotationTable() {
  return {
    type: actionTypes.INIT_QUOTATION_TABLE,
  };
}

export function setQuotationClassList(data) {
  return {
    type: actionTypes.SET_QUOTATION_CLASS_LIST,
    data,
  };
}

export function toggleQuotationCategoryEditing(data) {
  return {
    type: actionTypes.TOGGLE_QUOTATION_CATEGORY_EDITING,
    data,
  };
}
export function setQuotationCategoryAddVisible(data) {
  return {
    type: actionTypes.SET_QUOTATION_CLASS_ADD_VISIBLE,
    data,
  };
}
export function setQuotationSearchCondition(data) {
  return {
    type: actionTypes.SET_QUOTATION_SEARCH_CONDITION,
    data,
  };
}
export function setQuotationList(data) {
  return {
    type: actionTypes.SET_QUOTATION_LIST,
    data,
  };
}
export function setQuotationListPage(data) {
  return {
    type: actionTypes.SET_QUOTATION_LIST_PAGE,
    data,
  };
}
export function toggleQuotationInfoCategoryEditing(data) {
  return {
    type: actionTypes.TOGGLE_QUOTATION_INFO_CATEGORY_EDITING,
    data,
  };
}

export function setCurrentProductGroup(data) {
  return {
    type: actionTypes.SET_CURRENT_PRODUCT_GROUP,
    data,
  };
}
export function getQuotationClassList(param) {
  return (dispatch) => {
    get(QUOTATION_CLASS_LIST_GET, param)
      .then(res => {
        if (res.success) {
          dispatch(setQuotationClassList(res.content));
        }
      });
  };
}

export function getQuotationListByCond(data) {
  return (dispatch) => {
    get(QUOTATION_LIST_GET, data)
      .then(res => {
        if (res && res.success) {
          dispatch(setQuotationList(res.content));
        }
      });
  };
}

export function getQuotationList(param, cb) {
  return (dispatch) => {
    
    get(QUOTATION_LIST_GET, param)
      .then(res => { 
        if (res && res.success) {
          cb?.(res.content);
          dispatch(setQuotationList(res.content));
        }
      });
  };
}